import { render } from "./CaseDocuments.vue?vue&type=template&id=08244de5&scoped=true&ts=true"
import script from "./CaseDocuments.vue?vue&type=script&lang=ts"
export * from "./CaseDocuments.vue?vue&type=script&lang=ts"

import "./CaseDocuments.vue?vue&type=style&index=0&id=08244de5&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08244de5"]])

export default __exports__